import React, { useState, useEffect } from "react";
import Axios from "axios";
import Form from "react-bootstrap/Form";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { IBrandsFilterProps, IBrandAPI } from "./BrandsFilterProps";
import { FilterDropdown } from "./BrandsFilterHelpers";
import { guestServiceProvider } from "../../../../../services/ServiceProvider";

const BrandsFilters: React.FC<IBrandsFilterProps> = ({
  crsCodes,
  brands,
  handleBrandsChange,
  crsCodesBrands,
  brandsInUrl,
}) => {
  const [_isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState([]);
  const [brandsUrlFlag, setBrandsUrlFlag] = useState(true);
  useEffect(() => {
    const source = Axios.CancelToken.source();
    let didCancel = false;
    (async () => {
      if (!didCancel) {
        if (crsCodesBrands !== null) {
          setIsLoading(true);
          // const data = await coreGet(apiUrl, source);
          const guestService = await guestServiceProvider();
          const response = await guestService.brandFilterHotels(
            crsCodesBrands.split(",")
          );
          const brandFilterResult = [
            ...response.searchHotelsBrandsByHotelCodes?.results,
          ];
          if (brandFilterResult) {
            brandFilterResult.sort(function (a: any, b: any) {
              const roomA = parseInt(a.count);
              const roomB = parseInt(b.count);
              return roomB - roomA;
            });
            setFilters(brandFilterResult);
            setIsLoading(false);
          }
        } else {
          setFilters([]);
        }
      }
    })();
    return () => {
      didCancel = true;
      source.cancel("Request cancelled for brand filters.");
    };
  }, [crsCodes, crsCodesBrands]);

  useEffect(() => {
    const noFilters = filters === null || filters === undefined;
    const brandFilters = Object.keys(brands);
    // Remove non applicable filters.
    if (brandFilters.length) {
      brandFilters.forEach((brand) => {
        if (noFilters) {
          handleBrandsChange(
            {
              key: brand,
            },
            "delete"
          );
        } else {
          const found = filters.find(
            (filter: IBrandAPI) => filter.brandCode === brand
          );
          if (found === undefined) {
            handleBrandsChange(
              {
                key: brand,
              },
              "delete"
            );
          }
        }
      });
    }
    //default select the brands if present in the url params
    if (
      filters.length &&
      brandsInUrl &&
      brandsInUrl.length > 0 &&
      brandsUrlFlag
    ) {
      filters.forEach((brand: IBrandAPI) => {
        if (brandsInUrl.includes(brand.brandCode.toLocaleLowerCase())) {
          handleBrandsChange(
            {
              key: brand.brandCode,
              value: brand.brandCode,
            },
            "add"
          );
        }
      });
      setBrandsUrlFlag(false);
    }
  }, [filters, crsCodes, brands, handleBrandsChange]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const method = event.target.checked ? "add" : "delete";
    handleBrandsChange(
      { key: event.target.name, value: event.target.value },
      method
    );
  };
  const brandCount = Object.keys(brands).length;

  if (crsCodes !== null && filters !== null && filters.length) {
    return (
      <FilterDropdown>
        <Dropdown.Toggle variant="filter-dropdown" id="dropdown-brands">
          <span>{`Brand: ${brandCount} selected`}</span>
          <FontAwesomeIcon icon="chevron-down" />
        </Dropdown.Toggle>
        <Dropdown.Menu as={`ul`} className="p-3">
          {filters.map((filter: IBrandAPI) => {
            return (
              <li key={filter.brandCode}>
                <Form.Check
                  name={filter.brandCode}
                  value={filter.brandCode}
                  type="checkbox"
                  label={`${filter.name} (${filter.count})`}
                  id={`amenity-${filter.brandCode}`}
                  onChange={handleChange}
                  checked={!!brands[filter.brandCode]}
                />
              </li>
            );
          })}
        </Dropdown.Menu>
      </FilterDropdown>
    );
  }
  return null;
};

export default BrandsFilters;
